import React from 'react'
import Modal from './Modal'
import Envelope from '../icons/Envelope'

interface Props {
  isOpen: boolean
  email: string
  toggleModal: () => void
}

const EmailSentModal = ({ isOpen, email, toggleModal }: Props) => {
  return (
    <Modal isOpen={isOpen} toggleModal={toggleModal}>
      <div className="max-w-[47rem] bg-slateGray flex-1 mt-20 rounded-lg h-fit p-10 overflow-hidden scroll-container text-white">
        <div className="flex items-center justify-center">
          <div className="w-[8rem] h-[8rem] text-white">
            <Envelope />
          </div>
        </div>
        <div className="h-4" />
        <p className="text-22 font-domine text-center">Reset Password</p>
        <p className="text-16 text-center font-sans max-w-[30rem] mx-auto">
          We have sent an email to <span className="font-bold">{email}</span> with a link to reset your password. Please
          check your inbox and follow the link to create a new password.
        </p>
        <div className="h-4" />
        <div className="border-b border-lightBorder" />
        <div className="h-4" />
      </div>
    </Modal>
  )
}

export default EmailSentModal
